'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactElement, ReactNode } from 'react';
import ClientLogContextSyncComponent from '@spa/components/app/client-log-context-sync.component';
import IntlProvider from '@spa/lib/i18n/client/components/intl.provider';
import { LocaleContext } from '@spa/lib/react/context/LocaleContext';
import { OperatingChainContext } from '@spa/lib/react/context/OperatingChainContext';
import ReduxProvider from '@spa/components/redux/redux.provider';
import { RootState } from '@spa/lib/store/RootState';
import { RuntimeSearchParamsContext } from '@spa/lib/react/context/RuntimeSearchParamsContext';
import { SearchParams } from '@spa/lib/pages/SearchParams';
import SessionIdSyncComponent from '@spa/components/app/session-id-sync.component';
import SkipLinksComponent from '@spa/components/skip-links/skip-links.component';
import { TranslationsByIdByNamespace } from '@spa/lib/i18n/common/TranslationsByIdByNamespace';
export interface Props {
  readonly enableI18nWarnings: boolean;
  readonly locale: string;
  readonly children: ReactNode;
  readonly operatingChain: string;
  readonly searchParams?: SearchParams | null;
  readonly serverState: RootState;
  readonly translations: TranslationsByIdByNamespace;
}
function AppContextComponent(t0) {
  const $ = _c(19);
  const {
    enableI18nWarnings,
    children,
    locale,
    operatingChain,
    searchParams,
    serverState,
    translations
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SkipLinksComponent />;
    t2 = <ClientLogContextSyncComponent />;
    t3 = <SessionIdSyncComponent />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== serverState) {
    t4 = <ReduxProvider serverState={serverState}>{t1}{t2}{t3}{children}</ReduxProvider>;
    $[3] = children;
    $[4] = serverState;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== enableI18nWarnings || $[7] !== t4 || $[8] !== translations) {
    t5 = <IntlProvider translationsByIdByNamespace={translations} enableWarnings={enableI18nWarnings}>{t4}</IntlProvider>;
    $[6] = enableI18nWarnings;
    $[7] = t4;
    $[8] = translations;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== searchParams || $[11] !== t5) {
    t6 = <RuntimeSearchParamsContext.Provider value={searchParams}>{t5}</RuntimeSearchParamsContext.Provider>;
    $[10] = searchParams;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== locale || $[14] !== t6) {
    t7 = <LocaleContext.Provider value={locale}>{t6}</LocaleContext.Provider>;
    $[13] = locale;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== operatingChain || $[17] !== t7) {
    t8 = <OperatingChainContext.Provider value={operatingChain}>{t7}</OperatingChainContext.Provider>;
    $[16] = operatingChain;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
export default AppContextComponent;